import buttonResponses from "./standardButtonResponses"
import React from 'react'
import { CONSTANTS } from '../../renegadeOSLite/constants'

const rawData_home_loggedOut = [
    {
        id: "Opening line",
        uid: "7u0g3",
        nextState: null,
        buttons: [{
            text: "Free my mind from what?",
            nextState: "Existential Prison Cell",
            response: null
        }],
        typeResponse: true
    },
    // {
    //     id: "Who is this?",
    //     uid: "9ms19",
    //     nextState: null,
    //     buttons: [{
    //         text: "Free my mind from what?",
    //         nextState: "Existential Prison Cell",
    //         response: null
    //     }],
    //     replaceInProcessedHTML: {
    //         find: "I am  My name is N That's not important right now.",
    //         replace: "That's not important right now."
    //     },
    //     typeResponse: true
    // },
    {
        id: "Existential Prison Cell",
        uid: "we7zs",
        nextState: "Choose a pill",
        // typing: true,
        pause: true
    },
    {
        id: "Choose a pill",
        uid: "gilmp",
        nextState: null,
        isPillButton: true,
        buttons: [{
            text: "Take The Red Pill.",
            nextState: "The red pill",
            response: "Okay. I'll take the red pill.",
            style: "red"
        },{
            text: "Take The Blue Pill.",
            nextState: "The blue pill",
            response: "I'll take the blue pill, thanks.",
            style: "blue",
            ignoreOnPreload: true
        }]
    },
    {
        id: "The blue pill",
        uid: "ioxzv",
        nextState: null,
        isPillButton: true,
        buttons: [{
            text: "Take The Red Pill",
            nextState: "The red pill",
            response: "Okay. I'll take the red pill.",
            style: "red"
        }],
        ignoreOnPreload: true
    },
    {
        id: "The red pill",
        uid: "p6ydz",
        nextState: null,
        buttons: [{
            text: "Yes, I am thinking.",
            nextState: "Yes. I am thinking.",
            response: null
        },{
            text: "No, I'm not thinking.",
            nextState: "No. I am not thinking.",
            response: null
        }],
        startRenegadeOS: true
    },
    {
        id: "Yes. I am thinking.",
        uid: "yuzlc",
        buttons: [],
        nextState: "I think, therefore I am",
    },
    {
        id: "No. I am not thinking.",
        uid: "ikoni",
        buttons: [],
        nextState: "I think, therefore I am",
        ignoreOnPreload: true
    },
    {
        id: "I think, therefore I am",
        uid: "80s0l",
        buttons: [{
            text: "Yep! Keep going.",
            nextState: "Observer and observed"
        }]
    },
    {
        id: "Observer and observed",
        uid: "7m5jj",
        buttons: [{
            text: "Yep!",
            nextState: "Are they the same variable?"
        }],
    },
    {
        id: "Are they the same variable?",
        uid: "uoiua",
        buttons: [{
            text: "Yep! Keep going.",
            nextState: "Paradigms"
        }],
    },
    {
        id: "Paradigms",
        uid: "062q2",
        buttons: [{
            text: "What's the other paradigm?",
            nextState: "Materialism paradigm"
        }],
    },
    {
        id: "Materialism paradigm",
        uid: "08fsm",
        buttons: [{
            text: "Got it.",
            nextState: "Paradigms - part two"
        }],
    },
    {
        id: "Paradigms - part two",
        uid: "zwydk",
        buttons: [{
            text: "Show me.",
            nextState: "Do unicorns exist?"
        }],
    },
    {
        id: "Do unicorns exist?",
        uid: "mle15",
        buttons: [{
            text: "Yep! Keep going.",
            nextState: "There is no evidence for Y"
        }],
    },
    {
        id: "There is no evidence for Y",
        uid: "pj537",
        buttons: [{
            text: "I think so. Keep going...",
            nextState: "Y is redundant"
        }],
    },
    {
        id: "Y is redundant",
        uid: "zhw92",
        buttons: [{
            text: "Tell me.",
            nextState: "Spacetime is emergent"
        }],
    },
    // {
    //     id: "The question is a function",
    //     uid: "ei5a6",
    //     buttons: [],
    //     nextState: "Physics community is in a pickle",
    //     endTypewriterBlock: true
    // },
    // {
    //     id: "Physics community is in a pickle",
    //     uid: "bfa1a",
    //     //attachedComponent: CONSTANTS.ATTACHED_COMPONENTS.NOTE_FOR_COMPUTER_NERDS,
    //     buttons: [{
    //         text: "Tell me.",
    //         nextState: "Spacetime is emergent"
    //     }],
    // },
    {
        id: "Spacetime is emergent",
        uid: "evrgl",
        buttons: [{
            text: "Yes.",
            nextState: "Yes. I am a conscious system."
        },{
            text: "No.",
            nextState: "No. I am not a conscious system."
        }],
    },
    {
        id: "Yes. I am a conscious system.",
        uid: "x9dyo",
        buttons: [],
        nextState: "X is a conscious system",
    },
    {
        id: "No. I am not a conscious system.",
        uid: "u82qh",
        buttons: [],
        nextState: "X is a conscious system",
        ignoreOnPreload: true
    },
    {
        id: "X is a conscious system",
        uid: "lmt4r",
        buttons: [{
            text: "Yep! Keep going.",
            nextState: "X is a conscious system - part two"
        }],
    },
    {
        id: "X is a conscious system - part two",
        uid: "e6s9p",
        buttons: [{
            text: "Yep!",
            nextState: "My only postulate"
        }],
    },
    {
        id: "My only postulate",
        uid: "f4bxs",
        buttons: [{
            text: "Show me the evidence!",
            nextState: "Renegade OS is my evidence"
        }],
    },
    {
        id: "Renegade OS is my evidence",
        uid: "ruxxa",
        buttons: [{
            text: "Yeah, but what is Renegade OS?",
            nextState: "What is Renegade OS?"
        }],
    },
    {
        id: "What is Renegade OS?",
        uid: "ppnpe",
        buttons: [{
            text: "WTF does that even mean?",
            nextState: "Genius neuroscientist"
        }],
    },
    {
        id: "Genius neuroscientist",
        uid: "2ngea",
        buttons: [{
            text: "Sounds good!",
            nextState: "Conscious systems resist entropy",
            response: null
        }],
    },
    // {
    //     id: "What is free energy?",
    //     uid: "svyl0",
    //     buttons: [{
    //         text: "Sounds good!",
    //         nextState: "Conscious systems resist entropy",
    //         response: null
    //     }],
    // },
    {
        id: "Conscious systems resist entropy",
        uid: "6nqlp",
        buttons: [{
            text: "I think so. Keep going...",
            nextState: "Desert temperature"
        }],
    },
    // {
    //     id: "What is entropy?",
    //     uid: "tokqr",
    //     buttons: [{
    //         text: "I think so. Keep going...",
    //         nextState: "Desert temperature"
    //     }],
    // },
    {
        id: "Desert temperature",
        uid: "pokjh",
        buttons: [{
            text: "Okay...",
            nextState: "Antarctica"
        }],
    },
    {
        id: "Antarctica",
        uid: "f2psr",
        buttons: [{
            text: "That makes sense...",
            nextState: "Bring back to homeostasis"
        }],
    },
    {
        id: "Bring back to homeostasis",
        uid: "6y686",
        buttons: [{
            text: "Got it.",
            nextState: "You are a circle"
        }],
    },
    {
        id: "You are a circle",
        uid: "f4dh0",
        buttons: [{
            text: "Okay...",
            nextState: "You believe you are a star",
            response: null
        }],
    },
    {
        id: "You believe you are a star",
        uid: "czxzl",
        buttons: [{
            text: "Okay...",
            nextState: "Circle to star surprise",
            response: null
        }],
    },
    {
        id: "Circle to star surprise",
        uid: "eh08k",
        buttons: [{
            text: "I think so. Keep going...",
            nextState: "Two ways to restore homeostasis"
        }],
    },
    {
        id: "Two ways to restore homeostasis",
        uid: "5ffry",
        buttons: [{
            text: "Woah!",
            nextState: "Option 1"
        }],
    },
    {
        id: "Option 1",
        uid: "yg4ui",
        buttons: [{
            text: "Okay...",
            nextState: "A metaphorical circle"
        }],
    },
    {
        id: "A metaphorical circle",
        uid: "hje2f",
        buttons: [{
            text: "Tell me!",
            nextState: "Option 2"
        }],
    },
    {
        id: "Option 2",
        uid: "qeihm",
        buttons: [{
            text: "I think so.",
            nextState: "Who am I?"
        }],
    },
    {
        id: "Who am I?",
        uid: "91sxm",
        buttons: [{
            text: "Isn't that like the Law of Attraction?",
            nextState: "Law of attraction",
            response: null
        }],
    },
    {
        id: "Law of attraction",
        uid: "xem6f",
        buttons: [{
            text: "But surprising things happen all the time!",
            nextState: "Long Term System Correction",
            response: null
        }],
    },
    // {
    //     id: "Law of attraction - part two",
    //     uid: "l6j7s",
    //     buttons: [{
    //         text: "But surprising things happen all the time!",
    //         nextState: "Long Term System Correction",
    //         response: null
    //     }],
    // },
    {
        id: "Long Term System Correction",
        uid: "6dhl3",
        buttons: [{
            text: "How?",
            nextState: "A new quest",
            response: null
        }],
    },
    {
        id: "A new quest",
        uid: "d0aof",
        buttons: [{
            text: "You mean... I can bend reality?",
            nextState: "Bend the universe",
            response: null
        }],
    },
    {
        id: "Bend the universe",
        uid: "z8ogo",
        buttons: [{
            text: "So, I can't bend reality?",
            nextState: "Bending reality part two",
            response: null
        }],
    },
    {
        id: "Bending reality part two",
        uid: "4z7gd",
        buttons: [{
            text: "Yeah...",
            nextState: "Lucid dream part one",
            response: null
        },{
            text: "Nope...",
            nextState: "Lucid dream part one",
            response: null
        }],
    },
    {
        id: "Lucid dream part one",
        uid: "z3mtg",
        buttons: [{
            text: "Yeah, but who the hell are you?",
            nextState: "Who are you?",
            response: null
        }],
    },
    // {
    //     id: "Lucid dream part two",
    //     uid: "znap2",
    //     buttons: [{
    //         text: "Yeah, but, who the hell are you?",
    //         nextState: "Who are you?",
    //         response: null
    //     }],
    // },
    {
        id: "Who are you?",
        uid: "yjgoa",
        buttons: [{
            text: "What happened?",
            nextState: "Journey of discovery",
            response: null
        }],
        replaceInProcessedHTML: {
            find: "My name is Neo.Jks.I'm Nikki. ",
            replace: "I'm Nikki. "
        }
    },
    {
        id: "Journey of discovery",
        uid: "5rboe",
        buttons: [{
            text: "Err... yeah.",
            nextState: "Figure it out myself",
            response: null
        }],
    },
    {
        id: "Figure it out myself",
        uid: "314p3",
        buttons: [{
            text: "How?",
            nextState: "Trail of clues",
            response: null
        }],
    },
    {
        id: "Trail of clues",
        uid: "skhlp",
        buttons: [{
            text: "Then what happened?",
            nextState: "The epiphany",
            response: null
        }],
    },
    {
        id: "The epiphany",
        uid: "xowj3",
        buttons: [{
            text: "You already told me about this...",
            nextState: "Emergent patterns",
            response: null
        }],
    },
    {
        id: "Emergent patterns",
        uid: "dgjv9",
        buttons: [{
            text: "That's a pretty bold claim.",
            nextState: "Bold claim",
            response: null
        }],
    },
    {
        id: "Bold claim",
        uid: "n3vqk",
        buttons: [{
            text: "Well, I can't fault you for that.",
            nextState: "Private person",
            response: null
        }],
    },
    {
        id: "Private person",
        uid: "oj4a9",
        buttons: [{
            text: "An exception to what?",
            nextState: "Inside my mind",
            response: null
        }],
    },
    {
        id: "Inside my mind",
        uid: "rmf11",
        buttons: [{
            text: "I still don't understand what it is, though...",
            nextState: "A beautiful story",
            response: null
        }],
    },
    // {
    //     id: "Materialism OS",
    //     uid: "qin3y",
    //     buttons: [{
    //         text: "I think so. Keep going...",
    //         nextState: "Reasoning from second principles"
    //     }],
    // },
    // {
    //     id: "Reasoning from second principles",
    //     uid: "qrnsx",
    //     buttons: [{
    //         text: "But science can't answer those questions!",
    //         nextState: "Science can't answer those questions",
    //         response: null
    //     }],
    // },
    // {
    //     id: "Science can't answer those questions",
    //     uid: "6jdal",
    //     buttons: [{
    //         text: "How?",
    //         nextState: "The root cause of all problems",
    //         response: null
    //     }],
    // },
    // {
    //     id: "The root cause of all problems",
    //     uid: "werzm",
    //     buttons: [{
    //         text: "Well, that doesn't sound good...",
    //         nextState: "Evolve our thinking",
    //         response: null
    //     }],
    // },
    // {
    //     id: "Evolve our thinking",
    //     uid: "xboph",
    //     buttons: [{
    //         text: "A rebellion?",
    //         nextState: "A rebellion",
    //         response: null
    //     }],
    // },
    // {
    //     id: "A rebellion",
    //     uid: "1azzb",
    //     buttons: [{
    //         text: "I still don't get what it is, though...",
    //         nextState: "A beautiful story",
    //         response: null
    //     }],
    // },
    {
        id: "A beautiful story",
        uid: "czrdt",
        buttons: [{
            text: "So... it's a book?",
            nextState: "A book",
            response: null
        }],
    },
    {
        id: "A book",
        uid: "4te5c",
        buttons: [{
            text: "So is it fiction? Non-fiction? Memoir?",
            nextState: "Zac",
            response: null
        }],
    },
    // {
    //     id: "Weird baby",
    //     uid: "2ogsd",
    //     buttons: [{
    //         text: "Huh?",
    //         nextState: "Zac",
    //         //response: "<iframe src=\"https://giphy.com/embed/glmRyiSI3v5E4\" width=\"480\" height=\"354\" frameBorder=\"0\" class=\"giphy-embed\" allowFullScreen></iframe>"
    //     }],
    // },
    {
        id: "Zac",
        uid: "lekip",
        buttons: [{
            text: "What topics will we cover?",
            nextState: "Contents",
            response: null
        }],
    },
    {
        id: "Contents",
        uid: "r1gvr",
        buttons: [{
            text: "I've had a look at the contents.",
            nextState: "What do you think?",
            response: null
        }],
        openContents: true
    },
    {
        id: "What do you think?",
        uid: "3z1t3",
        buttons: [{
            text: "I'm intrigued.",
            nextState: "Crazy and grandiose",
            response: null
        }],
    },
    {
        id: "Crazy and grandiose",
        uid: "mwgef",
        buttons: [{
            text: "The Rebellion?",
            nextState: "A rebellion",
            response: null
        }],
    },
    {
        id: "A rebellion",
        uid: "1azzb",
        buttons: [{
            text: "Sounds fair.",
            nextState: "How are you feeling?",
            response: null
        }],
    },
    {
        id: "How are you feeling?",
        uid: "gyrec",
        buttons: [{
            text: "Take me to Renegade OS!",
            nextState: "Redirecting",
            response: null
        }],
        isLastChunk: true
    }
]

export default rawData_home_loggedOut
